<template>
  <article id="about">
    <h1>about me</h1>
    <section class="row">
      <div class="left">
        <p>Hey! My name is <span class="red">Alexander Wester</span>, but online you might know me as Piratkopia13 or Pirat. I'm a <span class="red">game engine programmer</span> at <a href="https://www.fatshark.se" target="_blank">Fatshark</a>, hobby <span class="red">quadcopter pilot</span> and <span class="red">alumni</span> at <a href="https://www.bth.se/eng/" target="_blank">Blekinge Institute of Technology</a> in Sweden. In august 2020, I finished my degree of Master of Science in Engineering: Game and Software Engineering. <!--Five hard-working years, and a few abstract math courses that had no obvious applications, have led me to this point.--></p>
        <p><span class="red">Programming</span> is something I enjoy both professionally and as a hobby. I mainly write C++ games or game engines with a focus on graphics, but also enjoy the occasional website, bash, or python project. Hardware and electronics are other interests of mine, especially applied in <span class="red">home automation</span>.</p>
        <p>Besides writing my own game engines, I also have experience with both <span class="red">UE4</span> and <span class="red">Unity</span>. I was mentioned in the <a href="https://twitter.com/Piratkopia13/status/983423896031514624" target="_blank">GamesMaster magazine</a> regarding a 2D puzzle platformer game that was being developed in UE4.</p>
        <!-- <p>I am the co-founder and programmer of the newly started <span class="red">Cimmeria studios</span>. We are a very small indie game studio with plans to create unique gaming experiences. You can follow Cimmeria on our <a href="https://twitter.com/CimmeriaStudios/" target="_blank">twitter</a>.</p> -->
        <p>If you wish to <span class="red">contact</span> me, feel free to use any of the social media linked at the top right of this page, or add me on discord @ Piratkopia13#9891</p>
        <!-- <p><b>I am currently looking for employment as a programmer within the gaming industry - if you believe I could fit at your company, or at a company you know are looking to hire - feel free to contact me!  </b></p> -->
      </div>
      <div id="avatar"></div>
    </section>
    <section id="quad" class="banner"></section>
  </article>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../variables.scss';

#quad {
  background: url('../assets/img_pattern.webp') repeat, url('../assets/banner_quad.webp')  center center no-repeat;
  background-size: auto, cover;
}

.row {
  display: flex;
}

.left {
  flex: 80%;
}

#avatar {
  flex: 20%;
  flex-basis: auto;
  height: auto;
  min-width: 250px;
  max-height: 500px;
  background: url('../assets/me.webp') center center no-repeat;
  background-size: cover;
  border-radius: 3em;
  border: 2px solid gray;
  margin: 20px;
}

#avatar:before {
  content: '';
  padding-top: 100%;
}

// when the screen is less than X px wide, make the two columns stack on top of each other instead of next to each other
@media screen and (max-width: 1500px) {
  .row {
    display: block;
  }
  #avatar {
    width: 400px;
    height: 400px;
    margin: 0 auto;
  }
}

</style>
